import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import GallerySection from "./components/GallerySection";
import ServicesSection from "./components/ServicesSection";
import FlowSection from "./components/FlowSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <GallerySection />
      <ServicesSection />
      <FlowSection />
      <TestimonialsSection />
      <FaqSection />
      <CtaBanner />
      <ContactSection />
      <Footer />
      <ScrollToTop />
    </div>
  );
}
